import React from "react";
import { Input, FormFeedback } from "reactstrap";
import * as Yup from "yup";
import { ArrowLeft, Mail } from "lucide-react";
import Select from "react-select";


export const Email = ({ sendEmailFormik, setEmail, onSubmit, isEmailClick }) => {

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
        sendEmailFormik.setFieldValue("email", e.currentTarget.value);
    }

    return (
        <>
            <div className="mb-4">
                <label htmlFor="email" className="form-label fw-medium">
                    Email address
                </label>
                <div className="position-relative">
                    <Mail className="position-absolute top-50 start-0 translate-middle-y ms-3 text-muted" />
                    <Input
                        id="email"
                        name="email"
                        autoFocus={true}
                        placeholder="Enter email address"
                        className="form-control ps-5"
                        value={sendEmailFormik.values.email}
                        onChange={(e) => handleEmailChange(e)}
                        onBlur={sendEmailFormik.handleBlur}
                        invalid={sendEmailFormik.touched.email && sendEmailFormik.errors.email ? true : false}
                    />
                </div>
                {sendEmailFormik.touched.email && sendEmailFormik.errors.email ? (
                    <FormFeedback> {sendEmailFormik.errors.email} </FormFeedback>
                ) : null}
            </div>



            <button
                type="button"
                disabled={isEmailClick}
                className={`btn btn-primary w-100 ${!sendEmailFormik.isValid ? 'disabled' : ''} `}
                onClick={onSubmit}
                style={isEmailClick ? { opacity: 0.7 } : {}}
            >
                Continue
            </button>
        </>
    );
};

export const Details = ({ accountFormik, isSubmitting, country_master_isd_icd, userType, email, setPhoneNumber, onBack, passwordShow, setPasswordShow, onSubmit }) => {

    return (
        <>
            <div className="mb-4">
                <button
                    type="button"
                    className="btn btn-link text-decoration-none ps-0"
                    onClick={onBack}
                >
                    <ArrowLeft className="me-2" size={16} />
                    Back
                </button>
            </div>
            <div className="mb-3">
                <label className="form-label">Company Name<span
                    className='required_star'>*</span></label>
                <Input
                    type="text"
                    name="companyName"
                    autoFocus={true}
                    value={accountFormik.values.companyName}
                    onChange={accountFormik.handleChange}
                    onBlur={accountFormik.handleBlur}
                    className="form-control"
                    placeholder="Enter Company name..."
                />
                {accountFormik.touched.companyName && accountFormik.errors.companyName ? (
                    <FormFeedback> {accountFormik.errors.companyName} </FormFeedback>
                ) : null}
            </div>

            <div className="row">
                <div className="col-md-6 mb-3">
                    <label className="form-label">First Name<span
                        className='required_star'>*</span></label>
                    <Input
                        type="text"
                        name="firstName"
                        value={accountFormik.values.firstName}
                        onChange={accountFormik.handleChange}
                        onBlur={accountFormik.handleBlur}
                        className="form-control"
                        placeholder="Enter First Name..."
                    />
                    {accountFormik.touched.firstName && accountFormik.errors.firstName ? (
                        <FormFeedback> {accountFormik.errors.firstName} </FormFeedback>
                    ) : null}
                </div>

                <div className="col-md-6 mb-3">
                    <label className="form-label">Last Name</label>
                    <Input
                        type="text"
                        name="lastName"
                        value={accountFormik.values.lastName}
                        onChange={accountFormik.handleChange}
                        onBlur={accountFormik.handleBlur}
                        className="form-control"
                        placeholder="Enter Last Name..."
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12 mb-2">
                    <label className="form-label">
                        Phone Number <span className="required_star">*</span>
                    </label>
                    <div className="d-flex align-items-center">
                        <div className="me-2" style={{ width: "100px" }}> {/* Adjust width as needed */}
                            <Select
                                name="opCode"
                                onChange={(e) => {
                                    accountFormik.setFieldValue("opCode", e.value);
                                }}
                                options={country_master_isd_icd}
                                value={country_master_isd_icd[1]}
                                placeholder="+91"
                                classNamePrefix="select2-selection form-select"
                            />
                            {accountFormik.touched.opCode && accountFormik.errors.opCode ? (
                                <FormFeedback> {accountFormik.errors.opCode} </FormFeedback>
                            ) : null}
                        </div>
                        <div className="flex-grow-1">
                            <Input
                                type="text"
                                name="phoneNumber"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                maxLength={10}
                                minLength={10}
                                value={accountFormik.values.phoneNumber || ''}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d*$/.test(value)) {
                                        setPhoneNumber(value);
                                        accountFormik.setFieldValue("phoneNumber", value);
                                    }
                                }}
                                onBlur={accountFormik.handleBlur}
                                className="form-control"
                                placeholder="Enter Phone Number..."
                            />
                            {accountFormik.touched.phoneNumber && accountFormik.errors.phoneNumber ? (
                                <FormFeedback> {accountFormik.errors.phoneNumber} </FormFeedback>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>

            <div className="mb-3">
                <label className="form-label">Email<span
                    className='required_star'>*</span></label>
                <Input
                    type="text"
                    name="email"
                    value={email}
                    className="form-control"
                    placeholder=""
                    disabled={true}
                />
            </div>

            <div className="row">
                <div className="mb-2">
                    <div className="d-flex align-items-start">
                        <div className="flex-grow-1">
                            <label className="form-label">Password</label>
                        </div>
                    </div>
                    <div id="enterPasswordArea" className="input-group auth-pass-inputgroup">
                        <Input
                            name="password"
                            value={accountFormik.values.password || ""}
                            type={passwordShow ? "text" : "password"}
                            placeholder="Enter password..."
                            onChange={accountFormik.handleChange}
                            onBlur={accountFormik.handleBlur}
                            invalid={
                                accountFormik.touched.password && accountFormik.errors.password ? true : false
                            }
                        />
                        <button onClick={() => setPasswordShow(!passwordShow)} className={`btn btn-light shadow-none ms-0 ${passwordShow ? 'show' : ''}`} type="button" id="onboarding-password-addon"></button>
                        {accountFormik.touched.password && accountFormik.errors.password ? (
                            <FormFeedback type="invalid">{accountFormik.errors.password}</FormFeedback>
                        ) : null}
                    </div>
                </div>
            </div>
            <div className={`form-check mb-2 mt-2 ${accountFormik.touched.acceptTerms && accountFormik.errors.acceptTerms ? 'bg-warning-subtle p-2 rounded' : ''}`}>
                <Input
                    type="checkbox"
                    className="form-check-input"
                    id="acceptTerms"
                    name="acceptTerms"
                    checked={accountFormik.values.acceptTerms || false}
                    onChange={e => accountFormik.setFieldValue("acceptTerms", e.target.checked)}
                    style={{ border: "1px solid #8787b3" }}
                />
                <label className="form-check-label" htmlFor="acceptTerms">
                    By selecting, you accept our{' '}
                    <span className="fw-bold text-primary">
                        <a
                            href="https://public-images-tarifftales.s3.ap-south-1.amazonaws.com/Terms_Conditions.html"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Terms of Use
                        </a>
                    </span>.
                </label>
                {accountFormik.touched.acceptTerms && accountFormik.errors.acceptTerms && (
                    <div className="invalid-feedback d-block">
                        {accountFormik.errors.acceptTerms}
                    </div>
                )}
            </div>
            <button
                type="button"
                className={`btn btn-primary w-100 mt-2 ${!accountFormik.isValid ? 'disabled' : ''}`}
                onClick={onSubmit}
                disabled={isSubmitting}>
                Create {userType} Account
            </button>
        </>
    );
};

const SignupForm = {
    Email,
    Details
};

export default SignupForm;
